import { lazy } from 'react'

export default lazy(
    () => 
    import('./InvoiceViewB2B') 
)